import { APP_CONFIG } from '@/utils/constants'
import HttpService from "@/utils/httpData"
import JWT from "@/utils/jwt"
import { log10 } from 'core-js/fn/number';

const getUserProfile = params => {
    let apiEndpoint = `profile`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getAllProvince = params => {
    let apiEndpoint = `EducationDepartment/GetAllProvince`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getTypePractice = params => {
    let apiEndpoint = `Home/GetListPracticeTypeFirst`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getUserProfileEdit = params => {
    let apiEndpoint = `profile-edit`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getUserInfo = params => {
    let apiEndpoint = `Home/GetUserInfo`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getBaseInfo = params => {
    let apiEndpoint = `Home/GetBaseInfo`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getHomeGetTimeTable = params => {
    let apiEndpoint = `Home/GetTimeTable`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getListClasses = params => {
    let apiEndpoint = `Classes/GetListClasses`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
 const getBookGroup = (params = {}) => {
    let apiEndpoint = `Home/GetListPracticeTypeSecond`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getSubjects = (params = {}) => {
    let apiEndpoint = `Home/GetListSubjectAndPracticeType`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getDetailProcessLearningByDate = (params = {}) => {
    let apiEndpoint = `Home/GetDetailProcessLearningByDate`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getListProcessChat = (params = {}) => {
    let apiEndpoint = `Home/ListProcessLearning`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getProcessPracticeChart = (params = {}) => {
    let apiEndpoint = `Home/GetProcessPracticeChart`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getListProcessLearning = (params = {}) => {
    let apiEndpoint = `Home/GetListProcessLearningChart`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getOverviewSubjectChart = (params = {}) => {
    let apiEndpoint = `Home/GetOverviewSubjectChart`;
    return HttpService.get(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getListActivityType = params => {
    let apiEndpoint = `Activity/GetListActivityType`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getListBookType = params => {
    let apiEndpoint = `Book/GetListBookType`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const updateLessonClass = params => {
    let apiEndpoint = `Home/UpdateLessonClass`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const updateUserInfo = params => {
    let apiEndpoint = `Home/UpdateUserInfo`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const updateParentInfo = params => {
    let apiEndpoint = `Home/UpdateParentInfo`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const getActivityList = params => {
    let apiEndpoint = `Activity/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const getListMyEbook = params => {
    let apiEndpoint = `Book/ListMyEbook`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const deleteLessonClass = (params = { data }) => {
    let apiEndpoint = `Home/DeleteLessonClass`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const apiDeleteActivity = (params = { data }) => {
    let apiEndpoint = `Activity/Delete`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const apiDeleteAllSchedule = (params = { data }) => {
    let apiEndpoint = `Home/DeleteLessonClassAllbyUser`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

export const createLessonClass = (params = { data }) => {
    let apiEndpoint = `Home/CreateLessonClass`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
const updateUserProfile = params => {
    let apiEndpoint = `update-user-profile`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}

const apiGetListSchoolType = params => {
    let apiEndpoint = `Home/GetListSchoolType`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export default {
    apiGetListSchoolType,
    getUserProfile,
    getUserProfileEdit,
    updateUserProfile,
    getHomeGetTimeTable,
    updateLessonClass,
    deleteLessonClass,
    getUserInfo,
    getBaseInfo,
    getListMyEbook,
    getListClasses,
    getListBookType,
    updateUserInfo,
    updateParentInfo,
    getActivityList,
    getAllProvince,
    getListActivityType,
    getTypePractice,
    getBookGroup,
    getSubjects,
    getProcessPracticeChart,
    getListProcessLearning,
    getOverviewSubjectChart,
    getListProcessChat,
    getDetailProcessLearningByDate
}